/**
 * Owner 2026-10-28 12:01 („Potwierdź ręcznie”): how a „Potwierdzony” was confirmed the last time, as the API sends it
 * per assignment (rule 7a: only with the field „Status”; `byName` with „Osoby: Podgląd”; `note` with the right to see it).
 */
export type Confirmation = { source: 'manual' | 'answer'; at: string; byName?: string; note?: string };

const DAY = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Warsaw' });
const TIME = new Intl.DateTimeFormat('pl-PL', { timeZone: 'Europe/Warsaw', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });

/** '…T11:05:00Z' → '28.10.2026 12:05' (Warsaw). */
export function dateTime(iso: string): string {
  const d = new Date(iso);
  const day = DAY.format(d);
  return `${Number(day.slice(8, 10))}.${Number(day.slice(5, 7))}.${day.slice(0, 4)} ${TIME.format(d)}`;
}

/**
 * The lines of the panel's ⓘ and of the grid's P-tile bubble: „Potwierdzone ręcznie przez Szef · 28.10.2026 12:05” or
 * „Odpowiedział(a) na zapytanie · 28.10.2026 11:40”, then „Uwagi: …”; not known (older data) — „brak danych”.
 */
export function confirmationLines(c: Confirmation | undefined): string[] {
  if (!c) return ['Potwierdzenie: brak danych'];
  const head = c.source === 'manual' ? `Potwierdzone ręcznie${c.byName ? ` przez ${c.byName}` : ''}` : 'Odpowiedział(a) na zapytanie';
  return [`${head} · ${dateTime(c.at)}`, ...(c.note ? [`Uwagi: ${c.note}`] : [])];
}
